module.exports = "/static/assets/226e066693229820e85b3c9f4f14480d.png";